export default "__VITE_ASSET__Dlp6ArDS__"